import React from 'react';

import SectionModel from '../../models/sectionModel';

import {
    DEPOT_BUSINESS_MENU_DATA, DEPOT_BUSINESS_MENU_DATA_EXPORT,
    DEPOT_BUSINESS_MENU_DATA_GET, DEPOT_BUSINESS_MENU_DATA_IMPORT,
    RESTAURANT_RESET_MENU_DATA,
} from '../../store/reducers/restaurant/restaurant-actions';

import {
    CONTROL_TYPE,
    MODEL_CONTROL_TYPE,
    ORDERING_MENU_TYPE_SECTION_MODEL,
    TYPE_SECTION_DEPOT_MODEL,
} from '../../utils/enums';
import { createBreadcrumbModel } from '../createBreadcrumbModel';
import { createControlModel, filtrateControlByDepotRole } from '../controlModelFactory';
import { getHistoryLocationParams } from '../../utils/routesHelper';
import { getDepotNameById } from '../restaurant';
import FilterOptionsModel from '../../models/filterOptionsModel.js';
import i18n from '../../i18n.js';
import { skuFilter } from '../filter.js';
import { Tooltip } from 'antd';

// Unified menu data: SKU and price of every product, option and suboption, base value and
// per-order-source override side by side. Small corrections happen here, bulk changes go
// through the exported spreadsheet and come back via Import.
export function createDepotBusinessMenuDataSectionModel({ ...args }) {
    return new SectionModel({
        filterOptions: createDepotBusinessMenuDataSectionFilter(),
        columns: [
            {
                columns: [
                    {
                        title: 'settings.menu_data.PROPERTY_NAME_LABEL',
                        accessor: 'name',
                        component: (item) => {
                            return <Tooltip className='itemWithTooltip' title={item.name}>
                                <span>{item.name}</span>
                            </Tooltip>
                        }
                    },
                ],
                accessor: 'menuData',
                isEditable: true,
                type: CONTROL_TYPE.menuData,
            },
        ],
        initNewItemModel: item => {
            return item;
        },
        actionName: DEPOT_BUSINESS_MENU_DATA,
        actionLoad: DEPOT_BUSINESS_MENU_DATA_GET,
        actionOnUnmount: RESTAURANT_RESET_MENU_DATA,
        typeAction: args.typeAction,
        typeModel: args.typeModel || ORDERING_MENU_TYPE_SECTION_MODEL.menuData,
        parentUrl: args.parentUrl || TYPE_SECTION_DEPOT_MODEL.depotsEdit,
        stayAfterSave: true,
        withSearch: true,
        breadcrumbs: [
            createBreadcrumbModel({
                label: 'settings.map.DEPOT_SETTINGS_LABEL',
            }),
            createBreadcrumbModel({
                getLabel: () => {
                    const { id } = getHistoryLocationParams(window.location.search);
                    return getDepotNameById(id);
                },
            }),
        ],
        label: 'settings.menu_data.LABEL',
        controls: filtrateControlByDepotRole([
            createControlModel({
                type: MODEL_CONTROL_TYPE.back,
            }),
            createControlModel({
                type: MODEL_CONTROL_TYPE.iconControl,
                icon: 'export',
                hideTooltip: true,
                text: i18n.t('settings.menu_data.EXPORT_LABEL'),
                action: DEPOT_BUSINESS_MENU_DATA_EXPORT,
            }),
            createControlModel({
                type: MODEL_CONTROL_TYPE.importFile,
                icon: 'import',
                text: i18n.t('settings.menu_data.IMPORT_LABEL'),
                action: DEPOT_BUSINESS_MENU_DATA_IMPORT,
            }),
            // Only `back` is stripped for a depot user. Bulk editing through the file is the
            // point of this screen and depot users are exactly who does it, so Import stays —
            // unlike on the SKU screen, which hides it from them.
        ], [MODEL_CONTROL_TYPE.back]),
        mappingLambda: state => {
            return {
                values: state.restaurant.data?.menuData,
                providers: state.restaurant.data?.menuDataSource,
            }
        },
    });
}

function createDepotBusinessMenuDataSectionFilter() {
    let filterOptionsModel = new FilterOptionsModel();

    filterOptionsModel.addOptions('search', CONTROL_TYPE.text, null, function(item) {
        return skuFilter(this.selected, item);
    });

    return filterOptionsModel;
}
